.divider {
	box-shadow: 0 2px 2px 0px var(--ds-border, var(--adg3-color-N40A));
	height: 4px;
	pointer-events: none; /* Don't block click events to elements below (e.g. the release bar) */
	position: relative;
	top: -4px;
	width: 100%;
	z-index: 4; /* this ensures that the box-shadow is rendered above the sticky group headings */
}

.dividerExportMode {
	width: 100%;
	border-top: 1px solid var(--ds-border, var(--adg3-color-N50));
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N40));
	pointer-events: none; /* Don't block click events to elements below (e.g. the release bar) */
}
